module.exports = __webpack_public_path__ + "static/img/36.97e0eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/36.png
// module id = 5W64
// module chunks = 1